import type { LessonConfig } from "../engine/lessonTypes";
import { IdeLessonView } from "./IdeLessonView";
import { ButtonLessonView } from "./ButtonLessonView";
import { PictureDemoView } from "./PictureDemoView";
import { PictureLessonView } from "./PictureLessonView";

interface LessonRendererProps {
  config: LessonConfig;
  onFinished: () => void;
}

export function LessonRenderer({ config, onFinished }: LessonRendererProps) {
  switch (config.type) {
    case "ide-demo":
    case "ide-lesson":
      return <IdeLessonView {...config} onFinished={onFinished} />;
    case "button":
      return <ButtonLessonView {...config} onFinished={onFinished} />;
    case "picture-demo":
      return <PictureDemoView {...config} onFinished={onFinished} />;
    case "picture":
      return <PictureLessonView {...config} onFinished={onFinished} />;
  }
}
